import CookieAgreement from "./CookieAgreement";

export default CookieAgreement
